import { getHistory } from "@relode/core";
import { JobCandidateStatus, JobStatus } from "@relode/core/domain";
import qs from "qs";

export interface CandidateSearchCriteria {
    jobCandidateStatus: JobCandidateStatus;
    jobStatus?: JobStatus[];
    isHiredConfirmed?: boolean;
    isInterviewingUpcoming?: boolean;
    showAllJobs?: boolean;
    jobScope?: number;
    jobScopeName?: string;
}

export const goToCandidateSearchStatus = (
    criteria: CandidateSearchCriteria
) => {
    const { jobCandidateStatus, showAllJobs, jobStatus, ...rest } = criteria;

    let searchCriteria = {
        jobCandidateStatusIds: [criteria.jobCandidateStatus.id],
        jobCandidateStatusNames: [criteria.jobCandidateStatus.description],
        jobStatusIds: criteria.jobStatus?.map(s => s.id),
        jobStatusNames: criteria.jobStatus?.map(s => s.description),
        ...rest,
    };

    if (showAllJobs !== true) {
        searchCriteria = {
            ...searchCriteria,
            jobScope: 1,
            jobScopeName: "My jobs",
        };
    }

    getHistory().push(
        `/candidates${qs.stringify(
            {
                pageSize: 25,
                pageIndex: 1,
                ...searchCriteria,
            },
            {
                skipNulls: true,
                addQueryPrefix: true,
                sort: (a, b) => a.localeCompare(b),
            }
        )}`
    );
};

export const goToJobSearchStatus = (status: JobStatus, showAllJobs?: boolean) =>
    goToJobSearch([status], showAllJobs);

export const goToJobSearch = (
    statuses: JobStatus[],
    showAllJobs?: boolean,
    hasCandidates?: boolean,
    hasHires?: boolean
) => {
    const jobStatusIds = [];
    const jobStatusNames = [];

    statuses.map((status: JobStatus) => {
        jobStatusIds.push(status.id);
        jobStatusNames.push(status.description);
    });

    let searchCriteria: any = {
        jobStatusIds: jobStatusIds,
        jobStatusNames: jobStatusNames,
        pageIndex: 1,
        pageSize: 25,
    };

    if (showAllJobs !== true) {
        searchCriteria = {
            ...searchCriteria,
            jobScope: true,
            jobScopeName: "My jobs",
        };
    }
    if (hasCandidates !== undefined) {
        searchCriteria = {
            ...searchCriteria,
            hasCandidates: hasCandidates,
        };
    }
    if (hasHires !== undefined) {
        searchCriteria = {
            ...searchCriteria,
            hasHires: hasHires,
        };
    }
    getHistory().push(
        `/jobs${qs.stringify(
            {
                ...searchCriteria,
            },
            {
                skipNulls: true,
                addQueryPrefix: true,
                sort: (a, b) => a.localeCompare(b),
            }
        )}`
    );
};
